import type {
  QuoteInquiryDetail,
  QuoteInquiryPageResponse,
  QuoteInquiryStatus,
  ReplyQuoteInquiryRequest,
  UpdateQuoteInquiryStatusRequest,
} from "../../../domain/types/quote-inquiry";
import type { CompanyQuoteInquiryApiService } from "../../api/company/company-quote-inquiry-api-service";
import { companyQuoteInquiryApiService } from "../../api/company/company-quote-inquiry-api-service";

export interface CompanyQuoteInquiryRepository {
  getQuoteInquiries(
    companyId: number,
    params: {
      status?: QuoteInquiryStatus;
      keyword?: string;
      page?: number;
      size?: number;
    }
  ): Promise<QuoteInquiryPageResponse>;

  getQuoteInquiry(
    companyId: number,
    inquiryId: number
  ): Promise<QuoteInquiryDetail>;

  replyQuoteInquiry(
    companyId: number,
    inquiryId: number,
    request: ReplyQuoteInquiryRequest
  ): Promise<QuoteInquiryDetail>;

  updateQuoteInquiryStatus(
    companyId: number,
    inquiryId: number,
    request: UpdateQuoteInquiryStatusRequest
  ): Promise<QuoteInquiryDetail>;
}

export class CompanyQuoteInquiryRepositoryImpl
  implements CompanyQuoteInquiryRepository
{
  constructor(private apiService: CompanyQuoteInquiryApiService) {}

  async getQuoteInquiries(
    companyId: number,
    params: {
      status?: QuoteInquiryStatus;
      keyword?: string;
      page?: number;
      size?: number;
    }
  ): Promise<QuoteInquiryPageResponse> {
    return this.apiService.getQuoteInquiries(companyId, params);
  }

  async getQuoteInquiry(
    companyId: number,
    inquiryId: number
  ): Promise<QuoteInquiryDetail> {
    return this.apiService.getQuoteInquiry(companyId, inquiryId);
  }

  async replyQuoteInquiry(
    companyId: number,
    inquiryId: number,
    request: ReplyQuoteInquiryRequest
  ): Promise<QuoteInquiryDetail> {
    return this.apiService.replyQuoteInquiry(companyId, inquiryId, request);
  }

  async updateQuoteInquiryStatus(
    companyId: number,
    inquiryId: number,
    request: UpdateQuoteInquiryStatusRequest
  ): Promise<QuoteInquiryDetail> {
    return this.apiService.updateQuoteInquiryStatus(
      companyId,
      inquiryId,
      request
    );
  }
}

export const companyQuoteInquiryRepository =
  new CompanyQuoteInquiryRepositoryImpl(companyQuoteInquiryApiService);
